<svg viewBox="0 0 37.41 22.05">
  <defs>
    <style>
      .cls-1 {
        fill: #fff;
      }

      .cls-2 {
        fill: #231f20;
      }
    </style>
  </defs>
  <title>Asset 15</title>
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <rect class="cls-1" width="37.41" height="22.05" />
      <path class="cls-2"
        d="M12.12,8.34a2.83,2.83,0,1,0,0,5.66,3.36,3.36,0,0,0,2.24-.95l.8.89a4.56,4.56,0,0,1-3.11,1.32,4.06,4.06,0,1,1,0-8.12,4.43,4.43,0,0,1,3.05,1.24l-.79,1A3.14,3.14,0,0,0,12.12,8.34Z" />
      <path class="cls-2" d="M17.83,6.69V15.2H16.52V6.69Z" />
      <path class="cls-2" d="M21.27,7.36a.77.77,0,1,1-.77-.8A.77.77,0,0,1,21.27,7.36ZM21.15,9.1v6.1H19.84V9.1Z" />
      <path class="cls-2"
        d="M29.52,12.17a2.82,2.82,0,0,1-2.89,3.08,2.39,2.39,0,0,1-2.15-1.1v3.28H23.16V9.1h1.32v1.05a2.37,2.37,0,0,1,2.13-1.1A2.87,2.87,0,0,1,29.52,12.17Zm-1.33,0a1.86,1.86,0,1,0-3.71,0,1.86,1.86,0,1,0,3.71,0Z" />
    </g>
  </g>
</svg>